import { render, staticRenderFns } from "./ShopPayQrcode.vue?vue&type=template&id=31d0f478&scoped=true"
import script from "./ShopPayQrcode.vue?vue&type=script&lang=js"
export * from "./ShopPayQrcode.vue?vue&type=script&lang=js"
import style0 from "./ShopPayQrcode.vue?vue&type=style&index=0&id=31d0f478&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d0f478",
  null
  
)

export default component.exports